// extracted by mini-css-extract-plugin
export var clearFilter = "SearchForm-module--clearFilter--RlLYI";
export var filterContainer = "SearchForm-module--filterContainer--O0jEi";
export var filterMulti = "SearchForm-module--filterMulti--ucosp";
export var form = "SearchForm-module--form--F1XDD";
export var searchHitsLabel = "SearchForm-module--searchHitsLabel--bThxq";
export var sortContainer = "SearchForm-module--sortContainer--y6yqA";
export var toggleButtonGroupLabel = "SearchForm-module--toggleButtonGroupLabel--bb-cm";
export var toggleButtonGroupWrapper = "SearchForm-module--toggleButtonGroupWrapper--2MAbe";